import { ReactNode } from 'react';
import { SafeAreaView, View } from 'react-native';
import { GlobalPopup } from '@/screens/HomeTherapist/GlobalPopup';
import NewUIModal from '@/components/ui/therapist/NewUIModal';
import { CollapsibleBody } from '@/components/ui/therapist/CollapsibleBody';
import { CollapsibleSidebar } from '@/components/ui/therapist/CollapsibleSidebar';

import { styles } from './styles';

export const BodyWrapper = ({
  children,
  bodyStyle,
  scrollEnabled,
  showSidebar = true,
}: {
  children: ReactNode;
  bodyStyle?: object;
  scrollEnabled?: boolean;
  showSidebar?: boolean;
}) => {
  return (
    <View style={{ flex: 1 }}>
      <SafeAreaView style={{ flex: 1 }}>
        <View style={styles.container}>
          <GlobalPopup />
          <NewUIModal />
          {showSidebar && <CollapsibleSidebar />}
          <CollapsibleBody scrollEnabled={scrollEnabled}>
            <View style={[styles.innerBodyWrapper, bodyStyle]}>{children}</View>
          </CollapsibleBody>
        </View>
      </SafeAreaView>
    </View>
  );
};
